<template>
  <div>
    <button class="btn btn-primary" @click="pesquisar">Recuperar Backup</button>
    <a
      class="btn btn-default"
      style="margin-left: 8px"
      href="/guia-restauracao-backup.pdf"
      download="guia-restauracao-backup.pdf"
    >
      <i class="fa fa-file-pdf-o"></i> Baixar guia de restauração
    </a>
  </div>
</template>

<script setup>
import { useMenu } from '@/composables/useMenu'
import BackupServico from '@/servicos/BackupServico'
import MensagemServico from '@/servicos/MensagemServico'

const mensagemServico = new MensagemServico()
const backupServico = new BackupServico()

useMenu(66)

async function pesquisar() {
  const resposta = await backupServico.recuperarBackup()

  if (!resposta || resposta?.erro) {
    if (resposta?.erro) {
      mensagemServico.alerta(resposta.erro.title, 'Erro')
    }

    return
  }

  if (resposta?.url) {
    window.open(resposta.url, '_blank')
  }
}
</script>
